import $ from 'jquery';

function fixMobileSectionsFp() {
    let $fwcc = $('.block-fullwidth-content-container');
    if ( $fwcc.length ) {
        let $fwcc_sections = $fwcc.find('section');
        let last_section = $fwcc.hasClass('last');
        let id = $($fwcc[0]).attr('id').slice(0, -1);
        let init_last_section = last_section;
        let html = '';

        if ($(window).width() < 992) {
            let count = 0;
            $fwcc_sections.each(function(index, el) {
                if (count === 0) {
                    html += openSection(id+index);
                }
                let section_content = $('<div/>');
                if ($(el).hasClass('block-fullwidth-simple-content')) {
                    section_content.append($(el).clone());
                    html += section_content.html();
                }
                if ($(el).hasClass('block-multiple-columns-colored-banner')) {
                    let $content_1 = $('<div/>').append($(el).clone());
                    let $content_2 = $('<div/>').append($(el).clone());
                    $content_2.attr('id', $($content_2).attr('id')+'-1');
                    if(count > 0) {
                        $content_1.find('.block-multiple-columns-colored-banner-content-container:not(:first-child)').remove();
                        $content_2.find('.block-multiple-columns-colored-banner-content-container').first().remove();

                    } else {
                        $content_1.find('.block-multiple-columns-colored-banner-content-container').first().remove();
                        $content_1.find('.block-multiple-columns-colored-banner-content-container:not(:first-child)').remove();
                    }
                    html += $content_1.html();
                    html += closeSection() + openSection();
                    html += $content_2.html();
                }
                count++;
                if(count === 2) {
                    html += closeSection();
                    count = 0;
                }
            });
            if(count > 0) {
                html+= closeSection();
            }

            let $insert_pos = $($fwcc[0]).prev('section');
            $fwcc.remove();
            $insert_pos.after($('<div/>').html(html).contents());
            // fix last section
            if (last_section) {
                let $last = $('.block-fullwidth-content-container').last();
                $last.addClass('last');
                if (!init_last_section) {
                    $last.removeClass('section fp-auto-height');
                }
            }
        }
    }
}


function openSection(id) {
    return '<section class="block-fullwidth-content-container section fp-auto-height fp-section" id="'+id+'">';
}

function closeSection() {
    return '</section>';
}


export default {
    fixMobileSectionsFp
}